import { BaseFeaturedSectionRouteStore } from "administration/naki-mobile/stores";

class NakiMobileHandheldFeaturedSectionRouteStore extends BaseFeaturedSectionRouteStore {
    constructor(rootStore) {
        super(rootStore);
    }
}

export default NakiMobileHandheldFeaturedSectionRouteStore;
